import { Model } from 'pinia-orm';
import { Str, Uid, Attr } from 'pinia-orm/decorators';
import type { PluginUsersPermissionsRole } from 'src/types/contentTypes';
import type { StrapiAttr } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type RoleAttr<K extends keyof PluginUsersPermissionsRole['attributes']> =
  StrapiAttr<PluginUsersPermissionsRole, K>;

export class Role extends Model {
  static override entity = 'roles';

  @Uid() declare id: number;
  @Str('') declare documentId: string;
  @Str('') declare type: RoleAttr<'type'>;

  @Attr(null) declare user_id: number;
}
